import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Auth from "service/AuthService";
import { useAuth } from "provider/AuthContext";
import InputField from "components/ui/forms/InputField";
import Button from "components/ui/Button";
import { FormMessage } from "components/ui/forms/FormMessage";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const ChangePassword = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [showPassword, setShowPassword] = useState({
    currentPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const AuthService = new Auth();
  const { logout } = useAuth();

  const {
    control,
    register,
    watch,
    handleSubmit,

    formState: { errors, isSubmitting },
  } = useForm();

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      setIsLoading(true);
      const response = await AuthService.userChangePassword({ newPassword: data.newPassword, currentPassword: data.currentPassword });
      if (response.success) {
        logout();
        toast.success("Password updated successfully please login again and start new session");
      } else {
        setErrorMessage(response.message || "Failed to change password. Please try again.");
      }
    } catch (error) {
      console.error("Error during change password:", error);
      setErrorMessage(error.response?.data.message || "An error occurred during change password. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const inputFields = [
    {
      name: "currentPassword",
      label: "Current Password",
      placeholder: "Enter current password",
      validation: { required: "Current Password is required" },
    },
    {
      name: "newPassword",
      label: "New Password",
      placeholder: "Enter new password",
      validation: {
        required: "New Password is required",
        // pattern: {
        //   value: validation.PASSWORD_REGEX,
        //   message: validation.INVALID_PASSWORD,
        // },
        validate: (value) => value !== watch("currentPassword") || "New password cannot be the same as the current password",
      },
    },
    {
      name: "confirmPassword",
      label: "Confirm Password",
      placeholder: "Confirm new password",
      validation: {
        required: "Confirm Password is required",
        validate: (value) => value === watch("newPassword") || "Passwords do not match",
      },
    },
  ];

  return (
    <div className="md:min-h-[calc(100vh-220px)] min-h-[calc(100vh-240px)] overflow-y-auto md:pr-1 pb-[60px]">
      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        {errorMessage && <FormMessage className="mb-6" message={errorMessage} />}
        <div className="grid grid-cols-1 gap-y-2 mb-6">
          {inputFields.map((field) => (
            <InputField
              key={field.name}
              type={showPassword[field.name] ? "text" : "password"}
              name={field.name}
              label={field.label}
              placeholder={field.placeholder}
              control={control}
              {...register(field.name, field.validation)}
              error={errors[field.name]?.message}
              postfixAction={() =>
                setShowPassword((prev) => ({
                  ...prev,
                  [field.name]: !prev[field.name],
                }))
              }
              postfix={
                !showPassword[field.name] ? <FaEye className="text-primary-dark" size={20} /> : <FaEyeSlash className="text-primary-dark" size={20} />
              }
            />
          ))}
          <div className="pt-5">
            <Button
              label={isLoading ? "Logging in..." : t("Change Password")}
              type="submit"
              size="small"
              variant="green"
              className="uppercase md:max-w-[370px] w-full ml-auto"
              disabled={isSubmitting}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default ChangePassword;
